export default __webpack_public_path__ + "static/media/free-nature-images.44b03ac3.jpg";